import { Grid, Stack, Typography, Box } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { useState } from "react";
import CustomDialogFooter from "../../../shared/components/CustomDialogFooter";

const colorSwatches = [
  null, // "no color" option
  "#C9D6C0",
  "#E8B5AC",
  "#CFC5C0",
  "#E3D3B5",
  "#FAD6A5",
  "#FAD4D4",
  "#C9F2CC",
  "#DCE3D4",
  "#D6C7E2",
  "#CFF6F5",
  "#F4C2C2",
  "#F7E8B4",
  "#D0EBF2",
  "#F9CBB5",
  "#FFD2F1",
];

export const BatchColourCodeDialog = ({
  handleClose,
  onSubmit,
  colour,
  updateBatchColour,
}) => {
  const [selectedColor, setSelectedColor] = useState(colour);

  return (
    <>
      <Stack p="8px 20px" gap="16px">
        <Typography fontSize="14px">Select from Swatches:</Typography>
        <Grid container spacing={1}>
          {colorSwatches.map((color, index) => (
            <Grid item xs={2} key={color || "no-color"}>
              <Box
                sx={{
                  width: "36px",
                  height: "36px",
                  borderRadius: "24px",
                  backgroundColor: color || "#ffffff",
                  border:
                    selectedColor === color
                      ? "2px solid #657083"
                      : "1px solid #ccc",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  position: "relative",
                }}
                onClick={() => setSelectedColor(color)}
              >
                {color === null && (
                  <svg width="28" height="26">
                    <line
                      x1="35"
                      y1="35"
                      stroke="#D32F2F"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                )}

                {selectedColor === color && (
                  <CheckIcon
                    sx={{
                      color: "#000",
                      fontSize: 18,
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                    }}
                  />
                )}
              </Box>
            </Grid>
          ))}
        </Grid>
      </Stack>
      <CustomDialogFooter
        handleClose={handleClose}
        onSubmit={onSubmit}
        updateBatchColour={updateBatchColour}
        state={selectedColor}
        disabled={updateBatchColour?.isPending}
      />
    </>
  );
};
